import clsx from 'clsx';
import { ReactNode } from 'react';
import { spacing } from '../../lib/constants';
import { SectionHeader } from './SectionHeader';
import { SectionContent } from './SectionContent';

interface Props extends BaseProps {
  children: ReactNode;
  fullWidth?: boolean;
  margin?: StandardSizes | 'none';
  padding?: StandardSizes | 'none';
  spacing?: NumberVariants;
}

/**
 *
 * Storybook:
 *
 * - [Section](https://www.google.com/)
 *
 * Child Components:
 *
 * - [SectionHeader](https://www.google.com/)
 * - [SectionContent](https://www.google.com/)
 *
 */

const Section = (props: Props) => {
  const {
    children,
    className,
    description = null,
    fullWidth = false,
    margin = 'md',
    padding = 'none',
    spacing = 1,
    ...rest
  } = props;
  const classes = useStyles();

  return (
    <section
      className={clsx(
        className,
        classes.default,
        classes.margin[margin],
        classes.padding[padding],
        classes.spacing[spacing],
        { [classes.fullWidth]: fullWidth }
      )}
      {...rest}
    >
      {children}
    </section>
  );
};

const useStyles = () => ({
  default: 'flex flex-col',
  fullWidth: 'w-full',
  margin: {
    sm: 'my-2',
    md: 'my-4',
    lg: 'my-8',
    none: 'm-0',
  },
  padding: {
    sm: 'p-2',
    md: 'p-4',
    lg: 'p-8',
    none: 'p-0',
  },
  spacing: spacing,
});

export { Section, SectionHeader, SectionContent };
